import * as privateEnv from '~config/privateEnv';
import * as publicEnv from '~config/publicEnv';
import { ShortcutResponse } from '~models/DiscoveryDto';
import { HttpClient, RequestParams } from '~utils/https/HttpClientFetch';

/**
 * @summary Discovery API
 * @privateBaseUrl https://private-api3.${TARGET_ENV_PREFIX}myrealtrip.net/private-discovery
 * @publicBaseUrl https://api3.${TARGET_ENV_PREFIX}myrealtrip.com/discovery
 *
 */

class DiscoveryApi<SecurityDataType> extends HttpClient<SecurityDataType> {
  v1 = {
    /**
     * @url GET /api/v1/web/gnb
     * @summary LNB 정보 조회 API
     * @description LNB 정보를 조회합니다.
     */
    fetchShortcut: (requestParams?: RequestParams) =>
      this.request<ShortcutResponse>({
        path: '/api/v1/web/gnb',
        method: 'GET',
        format: 'json',
        ...requestParams,
      }),
  };
}

export const IS_SSR = typeof window === 'undefined';

const discoveryApi = new DiscoveryApi({
  baseURL: IS_SSR ? privateEnv.DISCOVERY_API_ENDPOINT : publicEnv.DISCOVERY_API_ENDPOINT,
  secureWorker(securityData) {
    return {
      headers: {
        Authorization: `Bearer ${securityData}`,
      },
    };
  },
  secure: false,
});

export { discoveryApi };
